module.exports = __webpack_public_path__ + "img/medal.20388037.png";